import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CompleteFunctionRequestModel } from '../../model/completeFunctionRequestModel';
import { CompleteFunctionResponseModel } from '../../model/completeFunctionResponseModel';
import { environment } from '../../../environments/environment';

@Injectable()
export class CompleteFunctionService {
  
  private notifyCompleteFunctionRequestModel : EventEmitter<CompleteFunctionRequestModel> = new EventEmitter<CompleteFunctionRequestModel>();
  private notifyCompleteFunctionResponse: EventEmitter<CompleteFunctionResponseModel> = new EventEmitter<CompleteFunctionResponseModel>();

  constructor(private http : HttpClient) { }

  completeFunction(completeFunctionRequest:CompleteFunctionRequestModel){
    return this.http.post<CompleteFunctionResponseModel>(environment.server_url+"/api/CompleteFunction",completeFunctionRequest);
}

getNotifyCompleteFunctionRequestModel(){
  return this.notifyCompleteFunctionRequestModel;
}

getNotifyCompleteFunctionResponse(){
  return this.notifyCompleteFunctionResponse;
}
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/complete-function.service.ts